import * as service from './services'
import { to } from 'await-to-js'

export const actions = {

  async comprarPlanoComBoleto (context, subscriptionPayload) {
    const [error, response = { data: null }] = await to(service.comprarPlanoComBoleto(subscriptionPayload))
    if (error) {
      if (error.response) {
        context.dispatch('showPaymentErrorMsg', error.response.data.message)
      } else {
        context.dispatch('showPaymentErrorMsg', error.message)
      }
      return Promise.reject(error)
    }
    return response.data
  },

  async comprarPlanoComCredito (context, subscriptionPayload) {
    const [error, response = { data: null }] = await to(service.comprarPlanoComCredito(subscriptionPayload))
    if (error) {
      if (error.response) {
        context.dispatch('showPaymentErrorMsg', error.response.data.message)
      } else {
        context.dispatch('showPaymentErrorMsg', error.message)
      }
      return Promise.reject(error)
    }
    return response.data
  },

  async comprarServicoComBoleto (context, paymentPayload) {
    const [error, response = { data: null }] = await to(service.comprarServicoComBoleto(paymentPayload))
    if (error) {
      if (error.response) {
        context.dispatch('showPaymentErrorMsg', error.response.data.message)
      } else {
        context.dispatch('showPaymentErrorMsg', error.message)
      }
      return Promise.reject(error)
    }
    return response.data
  },

  async comprarServicoComCredito (context, paymentPayload) {
    const [error, response = { data: null }] = await to(service.comprarServicoComCredito(paymentPayload))
    if (error) {
      if (error.response) {
        context.dispatch('showPaymentErrorMsg', error.response.data.message)
      } else {
        context.dispatch('showPaymentErrorMsg', error.message)
      }
      return Promise.reject(error)
    }
    return response.data
  }

}



// WEBPACK FOOTER //
// ./src/store/payment/index.js